/*
 * File: \src\service\data-rangers\src\dataRangers.js
 * Created Date: 2020-11-05 09:14:26
 * Author: gaozw
 * -----
 * Last Modified: 2020-11-05 13:53:18
 * Modified By: gaozw
 */
import _config from './config'

class DataRangers {
  constructor () {
    this.loadNumber=0;
    this.isLoaded=false;
    this.defineDR();
    this.loadDR();
    this.init(_config.initConfig);
    this.setConfig(_config.paramsConfig)
    this.start()
  }

  defineDR(){
    const script = window.document.createElement('script')
    script.type = 'text/javascript'
    script.textContent=`(function(win, export_obj) {
        win['TeaAnalyticsObject'] = export_obj;
        if (!win[export_obj]) {
            function _collect() {
                _collect.q.push(arguments);
            }
            _collect.q = _collect.q || [];
            win[export_obj] = _collect;            
        }
        win[export_obj].l = +new Date();
    })(window, 'collectEvent');`
    window.document.head.appendChild(script)
  }

  checkLoaded() {
    return this.isLoaded
  }

  loadDR() {
    if (this.checkLoaded()) {
      return
    }
    // 超过尝试加载次数则加载失败
    if (this.loadNumber < _config.serviceConfig.loadNumberMax) {
      this.loadNumber++
      this.jsLoad()
        .then(this.loadSuccess.bind(this))
        .catch(this.loadError.bind(this))
    } else this.loadFail()
  }

  loadSuccess() {
    console.info('DataRangers load success!')
    this.isLoaded = true;
    this.emitApiQueue();
  }

  loadError(error) {
    console.error('DataRangers load error! number:', this.loadNumber)
    console.error(error)
    this.isLoaded = false
    window.setTimeout(this.loadDR,100)
  }

  loadFail() {
    console.error('DataRangers load fail!')
    this.isLoaded = false
    this.clearQueue()
  }

  jsLoad() {
    return new Promise((resolve, reject) => {
      try {
        const script = window.document.createElement('script')
        script.src = _config.serviceConfig.jsSrc
        script.type = 'text/javascript'
        script.async = true
        script.onload = ()=>{
            resolve()
        }
        script.onerror = error => reject(error)
        window.document.head.appendChild(script)
      } catch (err) {
        reject(err)
      }
    })
  }

  init(initParams){
    this.onEvent('init',initParams)
  }

  setConfig(params){
    this.onEvent('config',params)
  }

  start(){
    this.onEvent('start')
  }

  send(eventName,params){
    this.onEvent(eventName,params)
  }

  onEvent(actionName,params){
    if(this.isLoaded){
        if(params){
            window.collectEvent(actionName,params);
        }else{
            window.collectEvent(actionName);
        }
      }else{
        this.apiQueue.add({
            actionName,
            params:[params]
          })
      }
  }

  clearQueue() {
    this.apiQueue.clear()
  }

  get apiQueue() {
    if (!this._apiQueue) this._apiQueue = new Set()
    return this._apiQueue
  }

  emitApiQueue() {
    const queue = this.apiQueue
    queue.size && queue.forEach(({
      actionName,
      params
    }) => {
        this.onEvent.bind(this)(actionName,...params)
    })
    // clear queue
    queue.clear()
  }

}

export default DataRangers
